import { render, staticRenderFns } from "./FileForm15.vue?vue&type=template&id=69570a6a&scoped=true&"
import script from "./FileForm15.vue?vue&type=script&lang=js&"
export * from "./FileForm15.vue?vue&type=script&lang=js&"
import style0 from "./FileForm15.vue?vue&type=style&index=0&id=69570a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69570a6a",
  null
  
)

export default component.exports